
export function traverseFind_inArray(arr, fn) {

    for (let i=0; i < arr.length; i++) {
        let found = traverseFind(arr[i], fn)
        if (found)
            return found
    }
}

export function traverseArray(arr, fn) {

    for (let i=0; i < arr.length; i++)
        traverse(arr[i], fn)
}

export function traverse(tree, fn) {
    if (!tree) return
    fn(tree)

    if (tree.kids)
        tree.kids.forEach(n => traverse(n, fn))

    return tree
}

export function traverseFind(tree, fn) {
    
    if (!tree) return

    let found = fn(tree)
    if (found)
        return tree

    if (tree.kids) {
        for (let i=0; i < tree.kids.length; i++) {
            let k = tree.kids[i]
            let found = traverseFind(k, fn)
            if (found)
                return found
        }

    }
}

